<template>
  <td :class="classCss"  :style=" canNotEdit ? 'font-size:11px; vertical-align:middle;' : 'font-size:11px; vertical-align:middle;'"  v-if="!FixedIconTable" :colspan="colspan">
    <div></div>
    <i v-if="IsReturnDirectory" class="fa fa-exclamation-triangle text-danger" style="font-size:16px; align-self: center;" v-on:click="$emit('Edit', obj)" v-b-tooltip.hover :title="'Reprovado Diretoria'"></i>
    <a v-if="IsText && !isTextWarning" v-on:click="$emit('Edit', obj)" href="javascript:void(0)"  v-bind:class="{'text-danger':(Boolean(status) === false)}" :style="IsLineThrough ? 'text-decoration: line-through': ''">{{ (value) ? value: 'N/D' }}</a>
    <a v-if="IsTextLocked" v-on:click="$emit('Edit', obj)" href="javascript:void(0)"  v-bind:class="{'text-danger':(Boolean(status) === true)}" :style="IsLineThrough ? 'text-decoration: line-through': ''">{{ (value) ? value: 'N/D' }}</a>
    <a v-if="IsTextDanger" v-on:click="$emit('Edit', obj)" href="javascript:void(0)"  v-bind:class="{'text-danger font-weight-bold':(Boolean(status) === true)}" :style="IsLineThrough ? 'text-decoration: line-through': ''">{{ (value) ? value: 'N/D' }}</a>
    <a v-if="IsTextGreen" v-on:click="$emit('Edit', obj)" href="javascript:void(0)"  v-bind:class="{'text-dark font-weight-bold':(Boolean(status) === true)}" :style="IsLineThrough ? 'text-decoration: line-through': ''">{{ (value) ? value: 'N/D' }}</a>
    <a v-if="IsTextGreeen" v-on:click="$emit('Edit', obj)" href="javascript:void(0)"  v-bind:class="{'text-success font-weight-bold':(Boolean(status) === true)}" :style="IsLineThrough ? 'text-decoration: line-through': ''">{{ (value) ? value: 'N/D' }}</a>
    <a v-if="IsTextYellow" v-on:click="$emit('Edit', obj)" href="javascript:void(0)"  v-bind:class="{'text-warning font-weight-bold':(Boolean(status) === true)}" :style="IsLineThrough ? 'text-decoration: line-through': ''">{{ (value) ? value: 'N/D' }}</a>
    <a v-if="IsTextBlue" v-on:click="$emit('Edit', obj)" href="javascript:void(0)"  v-bind:class="{'text-primary font-weight-bold':(Boolean(status) === true)}" :style="IsLineThrough ? 'text-decoration: line-through': ''">{{ (value) ? value: 'N/D' }}</a>
    <a v-if="IsTextOrange" v-on:click="$emit('Edit', obj)" href="javascript:void(0)"  v-bind:class="{'font-weight-bold':(Boolean(status) === true)}" :style="'color: #e65c17'">{{ (value) ? value: 'N/D' }}</a>
    <a v-if="IsTextOrangeTecnico" v-on:click="$emit('Edit', obj)" href="javascript:void(0)"  v-bind:class="{'rascunho font-weight-bold':(Boolean(status) === true)}" :style="'color: #6a6a6a'">{{ (value) ? value: 'N/D' }}</a>
    <a v-if="isTextWarning" v-on:click="$emit('Edit', obj)" href="javascript:void(0)"  v-bind:class="'text-dark'" :style="IsLineThrough ? 'text-decoration: line-through': ''">{{ (value) ? value: 'N/D' }}</a>
    <a v-if="IsDatetime" v-on:click="$emit('Edit', obj)" href="javascript:void(0)"  v-bind:class  ="{'text-danger':(Boolean(status) === false)}" :style="IsLineThrough ? 'text-decoration: line-through': ''">{{ (value) ? moment(value).format('DD/MM/YYYY HH:mm') : 'N/D' }}</a>
    <a v-if="IsDateOnly && !IsDateOnlyWarning" v-on:click="$emit('Edit', obj)" href="javascript:void(0)"  v-bind:class="{'text-danger':(Boolean(status) === false)}" :style="IsLineThrough ? 'text-decoration: line-through': ''">{{ (value) ? moment(value).format('DD/MM/YYYY') : 'N/D' }}</a>
    <a v-if="IsDateOnlyWarning" v-on:click="$emit('Edit', obj)" href="javascript:void(0)"  v-bind:class="'text-dark'" :style="IsLineThrough ? 'text-decoration: line-through': ''">{{ (value) ? moment(value).format('DD/MM/YYYY') : 'N/D' }}</a>
    <a v-if="IsDecimal" v-on:click="$emit('Edit', obj)" href="javascript:void(0)"  v-bind:class="'text-dark'" :style="IsLineThrough ? 'text-decoration: line-through': ''">{{ (value) ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2}) : 'N/D' }}</a>
    <a v-if="IsInt" v-on:click="$emit('Edit', obj)" href="javascript:void(0)"  v-bind:class="{'text-danger':(Boolean(status) === false)}" :style="IsLineThrough ? 'text-decoration: line-through': ''">{{ value }}</a>
    <div v-if="IsStatus" v-on:click="$emit('Edit', obj)">
      <span v-if="status" class="badge badge-success text-toupper">{{$lang.Common.Status.Active}}</span>
      <span v-else class="badge badge-danger text-toupper">{{$lang.Common.Status.Inactive}}</span>
    </div>
    <div v-if="IsTextUnclicable">
      <span class="text-info" v-bind:class="{'text-danger':(Boolean(status) === false)}" :style="IsLineThrough ? 'text-decoration: line-through': ''">{{ (value) ? value : 'N/D' }}</span>
    </div>
    <div v-if="IsDateOnlyUnclicable">
      <span class="text-info" v-bind:class="{'text-danger':(Boolean(status) === false)}" :style="IsLineThrough ? 'text-decoration: line-through': ''">{{ (value) ? moment(value).format('DD/MM/YYYY HH:mm') : 'N/D' }}</span>
    </div>
    <div v-if="IsCustom" v-on:click="$emit('Edit', obj)" >
      <slot></slot>
    </div>
    <div v-if="IsDocumentActions" class="DocumentActions">
      <i v-show="HasDetails" v-on:click="$emit('Details', obj)" class="fas fa-eye text-secundary icone-grid" v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonDetails"></i>
      <i v-show="HasDownload" v-on:click="$emit('Download', obj)" class="fas fa-download ml-2 text-secundary icone-grid"  v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonDownload"></i>
      <i v-show="HasAssociar" v-on:click="$emit('Associar', obj)" :class="['fas fa-link ml-2 icone-grid', AssociarUnido ? 'icone-sap-feito' : 'icone-sap-pendente']"  v-b-tooltip.hover :title="AssociarUnido ? 'Já unido ao SAP' : 'Unir com SAP'"></i>
      <i v-show="HasEdit" v-on:click="$emit('Edit', obj)" class="fas fa-edit ml-2 text-secundary icone-grid"  v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonEdit"></i>
      <i v-show="HasAproved" v-on:click="$emit('aprovedIten', obj)" class="fas fa-thumbs-up ml-2 text-secundary icone-grid" style="color: green"  v-b-tooltip.hover title="Aprovar"></i>
      <i v-show="HasTrasparente" class="fas fa-thumbs-up ml-2 text-secundary iconTrasparente" style="color: transparent"></i>

      <b-dropdown v-if="HasDocumentDelete" variant="link" size="sm" no-caret class="ml-2" boundary="window">
        <template slot="button-content">
          <i class="fa fa-trash text-danger icone-grid" v-b-tooltip.hover :title="'Deletar'"/><span class="sr-only">{{$lang.Common.Buttons.Delete}}</span>
        </template>
        <b-dropdown-header><strong>{{$lang.Common.ConfirmDelete}}</strong></b-dropdown-header>
        <b-dropdown-item href="javascript:void(0);" v-on:click="$emit('Delete', obj)">{{$lang.Common.Yes}}</b-dropdown-item>
        <b-dropdown-item href="javascript:void(0);">{{$lang.Common.No}}</b-dropdown-item>
      </b-dropdown>
      <span class="sr-only"></span>
    </div>
    <div v-if="IsActionsButtons" class="d-flex justify-items-center align-items-center">
      <slot></slot>
      <i v-show="HasChange" v-if="status == 0" v-on:click="$emit('Change', obj)" class="fas fa-times text-danger icone-grid" v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonInactive"></i>
      <i v-show="HasChange" v-else v-on:click="$emit('Change', obj)" class="fa fa-check text-success icone-grid" v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonActive"></i>
      <i v-show="HasChange" style="padding-left:10px; font-size:16px;" v-if="newEditGama" v-on:click="$emit('Edit', obj)" class="fas fa-pen icon text-success icone-grid" v-b-tooltip.hover :title="'Editar'"></i>
      <i style="padding-left:10px; font-size:16px;cursor:pointer" v-show="NextStatus" @click="$emit('nextstatus', obj)" class="fas fa-angle-right"></i>
      <i v-show="HasPrint" style="padding-left:10px; font-size:16px;" v-on:click="$emit('Print', obj)" class="fas fa-print text-third icone-grid" v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonPrint"></i>
      <b-dropdown v-if="HasDelete" variant="link" size="sm" no-caret class="ml-2" boundary="window" dropleft>
        <template slot="button-content">
          <i class="fa fa-trash text-danger icone-grid"></i><span class="sr-only">{{$lang.Common.Buttons.Delete}}</span>
        </template>
        <b-dropdown-header><strong>{{$lang.Common.ConfirmDelete}}</strong></b-dropdown-header>
        <b-dropdown-item href="javascript:void(0);" v-on:click="$emit('Delete', obj)">{{$lang.Common.Yes}}</b-dropdown-item>
        <b-dropdown-item href="javascript:void(0);">{{$lang.Common.No}}</b-dropdown-item>
      </b-dropdown>
    </div>

    <div v-if="IsLotDetail" style="display: inline-flex;">
      <i v-show="HasDownloadUnico" v-on:click="$emit('Download', obj)" class="fas fa-download ml-2 text-secundary icone-grid"  v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonDownload"></i>
    </div>

    <div v-if="IsSurvey" style="display: inline-flex;">
      <!-- <button v-if="isSurveyButtonOk == false" class="btn btn-danger btn-sm mr-2"><i class="fas fa-info-circle"></i></button>
      <button v-if="isSurveyButtonOk" class="btn btn-success btn-sm mr-2"><i class="fas fa-check-circle"></i></button> -->
      <!-- <button class="btn btn-primary"><i class="fas fa-info"></i></button> -->
      <i  :disabled="apllicar == true ? false : true" v-on:click="$emit('Edit', obj)" href="javascript:void(0)" v-b-tooltip.hover title="Detalhes" class="fas fa-info-circle" style="color: #4b4b4b; font-size: 20px;"></i>
    </div>
    <div v-if="IsCustomButtons">
      <slot></slot>
    </div>

    <div v-if="newState" style="display:flex; justify-content:center">
      <div v-if="newStatusNumber == 0 && colorStatus == '' " id="newStatus" style="background-color: #DB3939;">{{descriptionNewStatus}}</div>
      <div v-if="newStatusNumber == 1 && colorStatus == ''" id="newStatus" style="background-color: #30A75F;">{{descriptionNewStatus}}</div>
      <div v-if="newStatusNumber == 2 && colorStatus == ''" id="newStatus" style="background-color: #F6B535;">{{descriptionNewStatus}}</div>
      <div v-if="newStatusNumber == 3 && colorStatus == ''" id="newStatus" style="background-color: #FE781E;">{{descriptionNewStatus}}</div>
      <div v-if="newStatusNumber == 4 && colorStatus == ''" id="newStatus" style="background-color: #2798E3;">{{descriptionNewStatus}}</div>
      <div v-if="newStatusNumber == 5" id="newStatus" style="background-color: #a1a1a1;">{{descriptionNewStatus}}</div>
      <div v-if="colorStatus != '' " id="newStatus" :style="{'background-color': colorStatus, 'color': fontColorStatus}" style="font-size: 12px;">{{descriptionNewStatus}}</div>
    </div>
    <div v-if="IsActionsDetails">
      <i v-show="HasChange" v-on:click="$emit('Details', obj)" class="fa fa-plus-square-o" v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonDetails"></i>
    </div>
    <div v-if="IsLighthouse">
      <div v-if="value==0">
        <i v-if="HasChange" class="fa fa-circle icon-background-gray font-xl" v-b-tooltip.hover title="Não contém histórico/semáforo"></i>
      </div>
      <div v-if="value==1">
        <i v-if="HasChange" class="fa fa-circle icon-background-green font-xl"></i>
      </div>
      <div v-if="value==2">
        <i v-if="HasChange" class="fa fa-circle icon-background-yellow font-xl"></i>
      </div>
      <div v-if="value==3">
        <i v-if="HasChange" class="fa fa-circle icon-background-red font-xl"></i>
      </div>
      <div v-if="value==5">
        <i v-if="HasChange" class="fa fa-circle icon-background-blue font-xl" v-b-tooltip.hover :title="description"></i>
      </div>
    </div>
  <div  class="edit-delete" v-if="IsActiveButton">
    <i v-show="HasChange" class="fa fa-download icon icone-grid" v-on:click="$emit('Download', obj)" style="padding-left:10px; font-size:16px; align-self: center;"  v-if="newEditGama && IsExpenseTravel" v-b-tooltip.hover :title="'Download Comprovante'"/>
    <div>
      <i v-show="HasChange" style="padding-left:10px; font-size:16px; align-self: center;" v-if="newEditGama" v-on:click="$emit('Edit', obj)" class="fas fa-pen icon text-success icone-grid" v-b-tooltip.hover :title="'Editar'"/>
    </div>
      <div  class="edit-delete" v-if="IsOnlyDownload">
    <i v-show="HasChange" class="fa fa-download icon icone-grid" v-on:click="$emit('Download', obj)" style="padding-left:10px; font-size:16px; align-self: center;" v-b-tooltip.hover :title="'Download Comprovante'"/>
  </div>
    <div>
      <i class="fa fa-plus text-success icone-grid" style="padding-left:10px; font-size:16px; align-self: center;" v-if="IsReinforcementTravel" v-on:click="$emit('ReinforcementTravel', obj)" v-b-tooltip.hover :title="'Reforço'"/>
    </div>
    <div class="lock-unlock" v-if="IsLockUnlock">
        <i id="locked" v-show="HasChange" style="padding-left:10px; font-size:16px; align-self: center;" v-if="IsLocked" v-on:click="$emit('Lock', obj)" class="fas fa-lock icon text-danger icone-grid" v-b-tooltip.hover :title="'Clique para Bloquear Colaborador'"/>
        <i id="locked" v-show="HasChange" style="padding-left:10px; font-size:16px; align-self: center;" v-else v-on:click="$emit('Lock', obj)" class="fas fa-lock-open icon icone-grid" v-b-tooltip.hover :title="'Clique para Desbloquear Colaborador'"/>
      </div>
  <i class="fa fa-plus text-success icone-grid" style="padding-left:10px; font-size:16px; align-self: center;" v-if="newEditGama && IsExpenseTravel" v-show="HasChange" v-on:click="$emit('Reinforcement', obj)" v-b-tooltip.hover :title="'Reforço'"/>
  <div  class="edit-delete" v-if="IsOnlyAprovaReprova">
    <i v-show="HasChange" class="fas fa-thumbs-up icone-grid text-success " v-on:click="$emit('aprova', obj)" style="padding-left:10px; font-size:16px; align-self: center;" v-b-tooltip.hover :title="'Aprovação acesso'"/>
    <i v-show="HasChange" class="fas fa-thumbs-down icon icone-grid text-danger" v-on:click="$emit('reprova', obj)" style="padding-left:10px; font-size:16px; align-self: center;" v-b-tooltip.hover :title="'Reprovação acesso'"/>
  </div>
  <div  class="edit-delete" v-if="IsOnlyAprova">
    <i v-show="HasChange" class="fas fa-thumbs-up icone-grid text-success " v-on:click="$emit('approveDisapprovedItem', obj)" style="padding-left:10px; font-size:16px; align-self: center;" v-b-tooltip.hover :title="'Aprovação acesso'"/>
  </div>
  <div  class="edit-delete" v-if="IsOnlyTrocarSenha">
    <i v-show="HasChange" class="fas fa-unlock-alt icone-grid text-success" v-on:click="$emit('resetarSenha', obj)" style="padding-left:10px; font-size:16px; align-self: center;" v-b-tooltip.hover :title="'Resetar Senha'"/>
  </div>
    <div class="ml-2" v-if="deletePopup">
      <i id="deletePopup" v-on:click="$emit('DeletePopup', obj)" class="fa fa-trash text-danger icone-grid" v-b-tooltip.hover :title="'Deletar'"/><span class="sr-only">{{$lang.Common.Buttons.Delete}}</span>
    </div>
    <b-dropdown v-if="HasDelete" variant="link" size="sm" no-caret class="ml-2" boundary="window">
        <template slot="button-content">
          <i class="fa fa-trash text-danger icone-grid" v-b-tooltip.hover :title="'Deletar'"/><span class="sr-only">{{$lang.Common.Buttons.Delete}}</span>
        </template>
        <b-dropdown-header><strong>{{$lang.Common.ConfirmDelete}}</strong></b-dropdown-header>
        <b-dropdown-item href="javascript:void(0);" v-on:click="$emit('Delete', obj)">{{$lang.Common.Yes}}</b-dropdown-item>
        <b-dropdown-item href="javascript:void(0);">{{$lang.Common.No}}</b-dropdown-item>
      </b-dropdown>
  </div>
  <div  class="edit-delete" v-if="IsOnlyDownloadSomente">
    <i v-show="HasChange" class="fa fa-download icon icone-grid" v-on:click="$emit('Download', obj)" style="padding-left:10px; font-size:16px; align-self: center;" v-b-tooltip.hover :title="'Download Comprovante'"/>
</div>
  <div  class="edit-delete" v-if="IsOnlyPedido">
    <!-- <i v-show="HasChange" class="fas fa-file icon icone-grid" v-on:click="$emit('Pedido', obj)" style="padding-left:10px; font-size:16px; align-self: center;" v-b-tooltip.hover :title="'Gerar Pedido'"/> -->
    <button v-show="HasChange" v-on:click="$emit('Pedido', obj)" class="button-pedido"  v-b-tooltip.hover :title="'Gerar Pedido'">PEDIDO</button>
  </div>
  <div>
    <i v-show="HasChange" style="padding-left:10px; font-size:16px; align-self: center;" v-if="newActiveGama" v-on:click="$emit('Active', obj)" class="fas fa-check text-success icone-grid" v-b-tooltip.hover :title="'Ativar'"/>
  </div>
  <div class="only-reinforcement" v-if="IsOnlyReinforcement">
    <i class="fa fa-search text-success icone-grid" style="padding-left:10px; font-size:16px; align-self: center;" v-if="IsExpenseTravel" v-on:click="$emit('Reinforcement', obj)" v-b-tooltip.hover :title="'Reforço'"/>
  </div>
  <div class="only-viewexpenses" style="display: flex; justify-content: center;" v-if="IsViewExpenses">
    <i class="fas fa-eye text-secundary icone-grid" style="margin-left:10px; font-size:16px; align-self: center;" v-on:click="$emit('DetailsExpense', obj)" v-b-tooltip.hover :title="'Visualizar Detalhes'"/>
    <i v-show="HasChange" style="padding-left:10px; font-size:16px; align-self: center;" v-on:click="$emit('Edit', obj)" class="fas fa-pen icon text-success icone-grid" v-b-tooltip.hover :title="'Editar'"/>
    <i class="fas fa-check text-secundary icone-grid" v-if="IsActive" style="color: #19692c  ;margin-left:10px; font-size:16px; align-self: center;" v-on:click="$emit('ActiveRegistration', obj)" v-b-tooltip.hover :title="'Ativar'"/>
    <i class="fas fa-times text-secundary icone-grid" v-if="IsDisable" style="color: #af0000; margin-left:10px; font-size:16px; align-self: center;" v-on:click="$emit('DisableRegistration', obj)" v-b-tooltip.hover :title="'Inativar'"/>
    <div class="ml-2" v-if="deletePopupTemplate">
      <i id="deletePopup" v-on:click="$emit('deleteTemplate', obj)" class="fa fa-trash text-danger icone-grid" v-b-tooltip.hover :title="'Excluir'"/>
    </div>
  </div>
  <div class="only-viewexpenses" v-if="IsViewExpensesTemplate">
    <i class="fas fa-eye text-secundary" style="font-size:14px; align-self: center;" v-on:click="$emit('DetailsExpenseTemplate', obj)" v-b-tooltip.hover :title="'Visualizar Detalhes do Template'"/>
    <i class="fas fa-pen text-secundary" style="font-size:14px; align-self: center;" v-on:click="$emit('editAPRTemplate', obj)" v-b-tooltip.hover :title="'Editar Template'"/>
    <i class="fas fa-clone text-secundary" style="font-size:14px; align-self: center;" v-on:click="$emit('CloneTemplate', obj)" v-b-tooltip.hover :title="'Clonar Template'"/>
    <i class="fa fa-trash text-danger" v-if="excluirTemplate" style="font-size:14px; align-self: center;" v-on:click="$emit('Exclusao', obj)" v-b-tooltip.hover :title="'Excluir item'"/>
  </div>
  <div v-if="newStateVistoria" style="display:flex; justify-content:center">
      <div id="newStatus" :style="{'background-color': colorStatusVistoria, 'color': fontColorStatusVistoria}" style="font-size: 11px; font-family: 'Segoe UI';">{{descriptionNewStatusVistoria}}</div>
  </div>

  </td>
</template>
<script>
export default {
  name: 'tableColumn',
  data () {
    return {
      obj: null
    }
  },
  methods: {
    openModal (modalRef) {
      this.$emit('openModal', modalRef)
    }
  },
  props: {
    status: {
      type: Number,
      required: false,
      default: 1
    },
    value: {
      type: String | Number,
      required: false
    },
    colspan: {
      type: String,
      required: false
    },
    newStateVistoria: {
      type: Boolean,
      required: false,
      default: false
    },
    colorStatusVistoria: {
      type: String,
      required: false,
      default: ''
    },
    fontColorStatusVistoria: {
      type: String,
      required: false,
      default: ''
    },
    descriptionNewStatusVistoria: {
      type: String,
      required: false,
      default: ''
    },
    HasAproved: {
      type: Boolean,
      required: false,
      default: false
    },
    HasTrasparente: {
      type: Boolean,
      required: false,
      default: false
    },
    classCss: {
      type: String,
      required: false,
      default: 'text-center'
    },
    newEditGama: {
      type: Boolean,
      required: false,
      default: false
    },
    newActiveGama: {
      type: Boolean,
      required: false,
      default: false
    },
    isTextWarning: {
      type: Boolean,
      required: false,
      default: false
    },
    excluirTemplate: {
      type: Boolean,
      required: false,
      default: false
    },
    IsTextBlue: {
      type: Boolean,
      required: false,
      default: false
    },
    IsTextOrange: {
      type: Boolean,
      required: false,
      default: false
    },
    IsText: {
      type: Boolean,
      required: false,
      default: false
    },
    IsTextUnclicable: {
      type: Boolean,
      required: false,
      default: false
    },
    NextStatus: {
      type: Boolean,
      required: false,
      default: false
    },
    IsTextOrangeTecnico: {
      type: Boolean,
      required: false,
      default: false
    },
    IsDatetime: {
      type: Boolean,
      required: false,
      default: false
    },
    IsDecimal: {
      type: Boolean,
      required: false,
      default: false
    },
    IsInt: {
      type: Boolean,
      required: false,
      default: false
    },
    FixedIconTable: {
      type: Boolean,
      required: false,
      default: false
    },
    IsDateOnlyWarning: {
      type: Boolean,
      required: false,
      default: false
    },
    newState: {
      type: Boolean,
      required: false,
      default: false
    },
    IsDateOnly: {
      type: Boolean,
      required: false,
      default: false
    },
    IsDateOnlyUnclicable: {
      type: Boolean,
      required: false,
      default: false
    },
    IsStatus: {
      type: Boolean,
      required: false,
      default: false
    },
    IsActionsButtons: {
      type: Boolean,
      required: false,
      default: false
    },
    IsSurvey: {
      type: Boolean,
      required: false,
      default: false
    },
    apllicar: {
      type: Boolean,
      required: false,
      default: false
    },
    isSurveyButtonOk: {
      type: Boolean,
      required: false,
      default: false
    },
    IsActionsDetails: {
      type: Boolean,
      required: false,
      default: false
    },
    IsLighthouse: {
      type: Boolean,
      required: false,
      default: false
    },
    canNotEdit: {
      type: Boolean,
      required: false,
      default: false
    },
    IsCustom: {
      type: Boolean,
      required: false,
      default: false
    },
    IsCustomButtons: {
      type: Boolean,
      required: false,
      default: false
    },
    IsLineThrough: {
      type: Boolean,
      required: false,
      default: false
    },
    HasChange: {
      type: Boolean,
      required: false,
      default: true
    },
    HasPrint: {
      type: Boolean,
      required: false,
      default: false
    },
    HasDetails: {
      type: Boolean,
      required: false,
      default: false
    },
    HasDownload: {
      type: Boolean,
      required: false,
      default: false
    },
    HasAssociar: {
      type: Boolean,
      required: false,
      default: false
    },
    AssociarUnido: {
      type: Boolean,
      required: false,
      default: false
    },
    HasEdit: {
      type: Boolean,
      required: false,
      default: false
    },
    HasDelete: {
      type: Boolean,
      required: false,
      default: true
    },
    hours: {
      type: String,
      required: false,
      default: '00:00'
    },
    description: {
      type: String,
      required: false,
      default: ''
    },
    newStatusNumber: {
      type: Number,
      required: false,
      default: 0
    },
    descriptionNewStatus: {
      type: String,
      required: false,
      default: ''
    },
    colorStatus: {
      type: String,
      required: false,
      default: ''
    },
    fontColorStatus: {
      type: String,
      required: false,
      default: ''
    },
    IsDocumentActions: {
      type: Boolean,
      required: false,
      default: false
    },
    IsActiveButton: {
      type: Boolean,
      required: false,
      default: false
    },
    IsExpenseTravel: {
      type: Boolean,
      required: false,
      default: false
    },
    IsOnlyReinforcement: {
      type: Boolean,
      required: false,
      default: false
    },
    IsViewExpenses: {
      type: Boolean,
      required: false,
      default: false
    },
    deletePopupTemplate: {
      type: Boolean,
      required: false,
      default: false
    },
    IsActiveDisable: {
      type: Boolean,
      required: false,
      default: false
    },
    IsViewExpensesTemplate: {
      type: Boolean,
      required: false,
      default: false
    },
    IsViewTemplateClone: {
      type: Boolean,
      required: false,
      default: false
    },
    IsOnlyAprovaReprova: {
      type: Boolean,
      required: false,
      default: false
    },
    IsOnlyAprova: {
      type: Boolean,
      required: false,
      default: false
    },
    IsOnlyTrocarSenha: {
      type: Boolean,
      required: false,
      default: false
    },
    IsLockUnlock: {
      type: Boolean,
      required: false,
      default: false
    },
    IsLocked: {
      type: Boolean,
      required: false,
      default: false
    },
    IsTextLocked: {
      type: Boolean,
      required: false,
      default: false
    },
    IsTextGreen: {
      type: Boolean,
      required: false,
      default: false
    },
    IsTextGreeen: {
      type: Boolean,
      required: false,
      default: false
    },
    IsTextDanger: {
      type: Boolean,
      required: false,
      default: false
    },
    IsTextYellow: {
      type: Boolean,
      required: false,
      default: false
    },
    HasDocumentDelete: {
      type: Boolean,
      required: false,
      default: true
    },
    IsReinforcementTravel: {
      type: Boolean,
      required: false,
      // ZC-32: era `defualt` (typo) — a prop nunca teve default declarado e o icone so nao aparecia
      // porque undefined e falsy. Explicito agora: nenhuma grid liga esse botao (o de Viagem saiu em
      // CollaboratorTableTravelExpense.vue), entao corrigir a palavra nao pode fazer ele voltar.
      default: false
    },
    deletePopup: {
      type: Boolean,
      required: false,
      default: false
    },
    IsOnlyDownload: {
      type: Boolean,
      required: false,
      default: false
    },
    IsOnlyDownloadSomente: {
      type: Boolean,
      required: false,
      default: false
    },
    IsOnlyPedido: {
      type: Boolean,
      required: false,
      default: false
    },
    IsLotDetail: {
      type: Boolean,
      required: false,
      default: false
    },
    HasDownloadUnico: {
      type: Boolean,
      required: false,
      default: false
    },
    IsReturnDirectory: {
      type: Boolean,
      required: false,
      default: false
    },
    IsActive: {
      type: Boolean,
      required: false,
      default: false
    },
    IsDisable: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>

<style>
.button-pedido{
    background-color: #008144;
    border-radius: 3px;
    border: transparent;
    padding: 4px;
    color: white;
    font-size: 9px;
}
.icone-grid-aprova {
  color: green
}
.icone-sap-feito {
  color: #008144;
}
.icone-sap-pendente {
  color: #a1a1a1;
}
.rascunho {
  color: #6a6a6a
}
.icone-grid-reprovar {
  color: rgb(177, 0, 0)
}
.edit-delete{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.texto-vermelho{
  color:red;
}

#newStatus{
  height: 25px;
  padding-top: 4px;
  font-size: 15px;
  border-radius: 25px;
  color: white;
  margin: 0px;
  width: 175px;
}
.iconTrasparente {
  font-size: 18px;
  vertical-align: middle;
}
.bg-yellow{
  background: #ffc10790!important;
}
.PositionBottom {
    position: sticky;
    height: 6%;
    display: flex;
}

.DocumentActions{
  display: flex;
}

.only-viewexpenses{
  display: flex;
  flex-direction: row;
  gap: 1rem;
  justify-content: center;
}

</style>



// WEBPACK FOOTER //
// src/components/forms/TableColumn.vue